module.exports = __webpack_public_path__ + "static/img/listwa_4.421279b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/urzadzenia/listwa_4.svg
// module id = usB0
// module chunks = 1